import { Box, Flex } from "@chakra-ui/react";
import { setGoogleAnalyticsEvent } from "src/common";
import { handleSSORedirect } from "src/services/ssoRedirect";
import { getAsideMenuLinkClass } from "./WidgetLink";
import { useTranslate } from "@tolgee/react";

const handleSSOLinkClick = (item, history, isImpersonating) => {
  handleSSORedirect(item, history, isImpersonating);
  setGoogleAnalyticsEvent({
    action: "portal_dashboard_tile_click",
    category: item.identifier,
    label: "sidebar_link",
  });
};

export const SSOLink = ({
  history,
  item,
  impersonation,
  isChild,
  inPopover,
}: {
  history: any;
  item: any;
  impersonation: any;
  isChild?: boolean;
  inPopover?: boolean;
}) => {
  let url;
  if (item.isDirectLink) url = item.href;
  const { t } = useTranslate();
  const itemLabel = item.hasCustomName
    ? item.label
    : t({ key: item.translatorDefaultNameKey, defaultValue: item.label });

  return (
    <Box
      as="a"
      cursor="pointer"
      href={url || "#"}
      target={item.openInNewWindow ? "_blank" : undefined}
      rel="noreferrer"
      data-aut={`Aside|SSOLink|${itemLabel}`}
      onClick={
        !url
          ? (e) => {
              e?.preventDefault();
              handleSSOLinkClick(item, history, impersonation?.isImpersonating);
            }
          : undefined
      }
      className={getAsideMenuLinkClass({ inPopover, isChild })}
    >
      <Flex>
        <span>{itemLabel}</span>
      </Flex>
    </Box>
  );
};
